module.exports = __webpack_public_path__ + "static/Section_Donation_Left_Tattoo-a3ceadcd347db4ce2be6bd1a910c5926.png";